export { importModule, initializeModules }

const MODULE_ATTRIBUTE = 'data-jsmodule';

/**
 * Load module or other file dynamicaly
 * @param _modulePath start from main javascript directory
 */
function importModule(_modulePath:string/*, _params:object, func:function*/){
    return import(/* webpackChunkName: "[request]" */`../../../${_modulePath}`)
}

function initializeModules(wrapper:HTMLElement|Document|null): Promise<void> {
    return new Promise((resolve) => {
        if (!wrapper) {
            wrapper = document;
        }
        // Check what we have there
        const _modules = wrapper.querySelectorAll(`[${MODULE_ATTRIBUTE}]`);
        // If nothing just resolve
        if (_modules.length == 0) {
            resolve();
        }
        // If something lets load
        else {
            // Counter for modules
            let quantity = 0;
            const updateQ = () => {
                quantity += 1;

                if (quantity === _modules.length) {
                    resolve();
                }
            };
            // Initialization
            _modules.forEach((module) => {
                const _moduleName = module.getAttribute(MODULE_ATTRIBUTE) || '';
                if (_moduleName.length > 1) {
                    importModule(`modules/${_moduleName}`)
                    .then((src) => {
                        if (typeof src.initAfterDynamicImport == 'function') {
                            src.initAfterDynamicImport(module);
                        }
                    }).catch((e) => {
                        console.log('%cIMPORT Błąd modułu: '+ _moduleName + ' '+ Date.now(), 'color:red');
                        console.log(e);
                    }).finally(() => {
                        updateQ();
                    });
                } else {
                    updateQ();
                }
            });
        }
    });
}
